<template>
  <div class="video-wrap">
    <div style="display: flex">
      <div class="filter">
        <el-input class="filter-item" v-model="formSearch.name" placeholder="请输入名称"></el-input>
        <el-input class="filter-item" v-model="formSearch.title" placeholder="请输入标题"></el-input>
        <el-select clearable class="filter-item" v-model="formSearch.channel" filterable placeholder="请选择频道" @change="changeChannelId">
          <el-option v-for="item in channelList" :key="item.channelId" :label="item.channelName" :value="item.channelId"> </el-option>
        </el-select>
        <el-select clearable class="filter-item" v-model="formSearch.playlistId" filterable placeholder="请选择播放列表">
          <el-option v-for="item in playList" :key="item.id" :label="item.playName" :value="item.id"> </el-option>
        </el-select>
        <el-select clearable class="filter-item" v-model="formSearch.creatorId" filterable placeholder="请选择操作人员">
          <el-option v-for="item in operatorList" :key="item.bizId" :label="item.bizName" :value="item.bizId"> </el-option>
        </el-select>
        <el-date-picker
          v-model="formSearch.formdate"
          type="daterange"
          class="filter-item"
          style="width: 240px"
          align="right"
          size="small"
          unlink-panels
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          :clearable="false"
        ></el-date-picker>
        <el-button @click="handleReset">重置</el-button>
        <el-button @click="handleSearch" type="primary">查询</el-button>
        <el-button @click="uploadVideo" type="primary">上传</el-button>
      </div>
      <div>
        <el-button @click="exportExcel">导出</el-button>
        <el-button @click="handerRefresh" :disabled="loading">同步</el-button>
      </div>
    </div>
    <div class="table">
      <el-table :border="false" id="rebateSetTable" v-loading="loading" :data="tableData" style="width: 100%" height="100%">
        <el-table-column v-for="item of videoTableColumns" :label="item.label" :key="item.prop" :prop="item.prop" :width="item.width">
          <template slot-scope="scope">
            <div v-if="item.prop === 'videoId'">
              {{ scope.row.videoId }}
              <i @click="copyText(scope.row.videoId)" class="el-icon-document-copy" style="color: #1890ff; cursor: pointer"></i>
            </div>
            <div v-else-if="item.prop === 'madeForKid'">
              {{ scope.row.madeForKid === 1 ? "内容是面向儿童" : "内容不是面向儿童" }}
            </div>
            <div v-else-if="item.prop === 'operate'">
              <el-button type="text" @click="editTag(scope.row)">编辑</el-button>
              <el-button type="text" @click="deleteTag(scope.row)">删除</el-button>
            </div>
            <div v-else-if="item.prop === 'thumbnailUrl'">
              <img :src="scope.row.thumbnailUrl" style="max-height: 80px" />
            </div>
            <div v-else-if="item.prop === 'videoUrl'">
              <a :href="scope.row.videoUrl" target="_black">{{ scope.row.videoUrl }}</a>
              <i
                @click="copyText(scope.row.videoUrl)"
                class="el-icon-document-copy"
                style="color: #1890ff; cursor: pointer; margin-left: 6px"
              ></i>
            </div>
            <span v-else> {{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
      </el-table>
      <self-pagination
        :total="pageData.total"
        :pageSize="pageData.size"
        :currentPage="pageData.page"
        ref="tabelPagination"
        @getCurrentPage="changePage"
        @handleSizeChange="changePageSize"
      ></self-pagination>
    </div>
    <add-video-modal ref="addVideo" @successCallBack="handleReset"></add-video-modal>
  </div>
</template>

<script>
import { videoTableColumns } from "./config";
import { changeshortcutclass, clearallshortcutclass } from "@/utils/tool";
import AddVideoModal from "./AddVideoModal.vue";
import moment from "moment";
import { getYoutubeFiles, getChannelOptions, refreshYouTubeVideoList, getYouTubePlayList } from "@/api/property.js";
import { getOperatorList } from "@/api/api";
import { downLoadWrokSheet } from "@/utils/commonTools";
import { copyText } from "@/utils/tool.js";
export default {
  components: {
    AddVideoModal,
  },

  data() {
    return {
      formSearch: {
        name: "",
        title: "",
        channel: "",
        playlistId: "",
        creatorId: "",
        formdate: [new Date(new Date().getTime() - 3600 * 1000 * 24 * 6), new Date()],
      },
      channelList: [],
      playList: [],
      operatorList: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "当天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("当天", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近一周", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近一个月", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近2个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近2个月", picker.$el);
              }, 0);
            },
          },
        ],
        onPick: function ({ maxDate, minDate }) {
          clearallshortcutclass(this.$el);
          console.log(maxDate, minDate);
        },
        disabledDate: function (date) {
          if (new Date().getTime() - date.getTime() > 0) {
            return false;
          }
          return true;
        },
      },
      videoTableColumns,
      tableData: [],
      loading: false,
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
    };
  },

  computed: {},

  watch: {},

  mounted() {
    this.getList();
    this.initSelect();
  },

  methods: {
    getList() {
      this.loading = true;
      const { name, title, channel, formdate, playlistId, creatorId } = this.formSearch;
      getYoutubeFiles({
        beginTime: moment(formdate[0]).format("YYYYMMDD"),
        endTime: moment(formdate[1]).format("YYYYMMDD"),
        name,
        title,
        channel,
        playlistId,
        creatorId,
        size: this.pageData.size,
        page: this.pageData.page,
      })
        .then((res) => {
          this.loading = false;
          if (res.code === "0000") {
            this.tableData = res.data.list;
            this.pageData.total = res.data.total;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    initSelect() {
      getChannelOptions().then((res) => {
        this.channelList = res.data;
        this.changeChannelId();
      });
      getOperatorList({ type: 1 }).then((res) => {
        this.operatorList = res.data;
      });
    },
    changeChannelId() {
      this.formSearch.playlistId = "";
      getYouTubePlayList({
        channelId: this.formSearch.channel,
      }).then((res) => {
        this.playList = res.data;
      });
    },
    handleReset() {
      this.formSearch = {
        name: "",
        title: "",
        channel: "",
        playlistId: "",
        creatorId: "",
        formdate: [new Date(new Date().getTime() - 3600 * 1000 * 24 * 6), new Date()],
      };
      this.changeChannelId();
      this.pageData.page = 1;
      this.getList();
    },
    handleSearch() {
      this.pageData.page = 1;
      this.getList();
    },
    uploadVideo() {
      this.$refs.addVideo.openModal();
    },
    copyText(text) {
      if (copyText(text)) {
        this.$message({
          message: "复制成功",
          type: "success",
        });
      }
    },
    exportExcel() {
      const data = JSON.parse(JSON.stringify(this.tableData));
      const haderData = {};
      const columns = this.videoTableColumns;
      const dataList = this.formatTableData(data);
      columns.forEach((item) => {
        haderData[item.prop] = item.label;
      });
      downLoadWrokSheet(dataList, "YouTube视频.xlsx", haderData);
    },
    formatTableData(list) {
      return list.map((item) => {
        item.madeForKid = item.madeForKid === 1 ? "内容是面向儿童" : "内容不是面向儿童";
        return item;
      });
    },
    handerRefresh() {
      this.loading = true;
      const { channel, playlistId } = this.formSearch;
      refreshYouTubeVideoList({
        channel,
        playlistId,
      })
        .then((res) => {
          this.loading = false;
          if (res.code === "0000") {
            this.handleReset();
            this.$message.success("同步成功");
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    changePage(page) {
      this.pageData.page = page;
      this.getList();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.video-wrap {
  height: calc(~"100vh - 210px");
  .filter {
    flex: 1;
    .filter-item {
      margin-right: 16px;
      width: 200px;
      margin-bottom: 10px;
    }
  }
  .table {
    height: calc(100% - 100px);
    margin-top: 20px;
  }
}
</style>
